<template>
  <div class="product-and-hs-template">
    <span class="form-title">{{ $i18.language('设定推荐条件：') }}<span class="form-desc">{{ $i18.language('（关键词与税号对应）') }}</span></span>
    <template v-for="(item, index) in form.interestedProducts">
      <div class="label-box flex-right">
        <!-- <el-popover placement="bottom" width="472" class="exclude-btn" popper-class="auto-translate-popper" :visible-arrow="false" trigger="click">
          <auto-translate
            :keyWordsList="[item]"
            @changeAuto="
              (val) => {
                changeAuto(val, item)
              }
            "
            :autoTranslate="item.autoTranslate"
            ref="autoTranslate"
            @change="mapData"
          ></auto-translate>
          <span class="auto-trans" slot="reference"
            >{{ $i18.language('自动翻译') }}<span v-if="item.autoTranslate">({{ $i18.language('开') }})</span>
          </span>
        </el-popover> -->
        <span class="hscode-text auto-trans" :class="{'is-disabled': disabled}" @click="hscodeSearch(item)">{{ $i18.language('编码查询') }}</span>
      </div>
      <multiple-prepend
        :key="index"
        :params="item"
        type="2"
        className="allNetKeyWord-input"
        :selectIndex="index"
        :isPlus="index === 0"
        :disabled="disabled"
        @loseBlur="
          (val) => {
            loseBlur(item, index, val)
          }
        "
        @operation="
          (val) => {
            operation(index, val)
          }
        "
        :index="index"
      ></multiple-prepend>
    </template>
  </div>
</template>

<script>
import autoTranslate from '@/views/Trade/components/TradeResults/AdvancedFilter/autoTranslate'
import multiplePrepend from './multiplePrepend'
export default {
  name: 'Gt50ProductAndHs',
  components: {
    autoTranslate,
    multiplePrepend
  },
  props: {
    form:{
      type: Object,
      default:{}
    },
    // 默认表单结构
    defaultHsForm: {
      type: [Object, Function]
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    maxLength: {
      type: Number,
      default: 4
    }
   },
  data() {
    return {
      
    };
  },

  mounted() {
    
  },

  methods: {
    // 改变自动翻译
    changeAuto(val, data) {
      this.$set(data, 'autoTranslate', val)
    },
    mapData() {
      console.log(this.form.hsCodes, 'wlll');
      // this.$set(this.form, 'data', JSON.parse(JSON.stringify(this.form.hsCodes)))
    },
    // 打开HS编码弹框
    hscodeSearch(data) {
      if(this.disabled) return
      this.$emit("hscodeSearch", data)
    },
    // 关键词和hs编码失焦
    loseBlur(data, index, key) {
      if(key=='key') {
        this.$set(data, 'value', data.key[0]||'')
      }
    },
    //检查字段是否全部填写完成
    checkFields() {
      let flag = false
      const obj = this.form
      const hasEmptyKey = this.form.interestedProducts.some((item) => !item.value && !item.hscodes?.length)
      const overSize = this.form.interestedProducts.some((item) => item.hscodes?.length && item.hscodes.length >5 )
      flag = hasEmptyKey || overSize
      return flag
    },
    // 新增和删除
    operation(index, isPlus) {
      if (isPlus) {
        if (this.form.interestedProducts.length > this.maxLength) {
          let message = `${this.$i18.language('最多支持')}${this.maxLength+1}${this.$i18.language('条')}`
          this.$message.warning(message)
          return
        }
        this.form.interestedProducts.push(this.defaultHsForm())
      } else {
        this.form.interestedProducts.splice(index, 1)
      }
    }
  },
};
</script>
<style lang="scss" scoped>
.product-and-hs-template {
  overflow-y: auto;
  max-height: 280px;
  position: relative;
  &::-webkit-scrollbar {
    width: 5px; /* Chrome Safari */
    height: 5px;
  }
  &::-webkit-scrollbar-thumb {
    background: $--scrollbar-thumb-color; // 滑块颜色
    border-radius: 5px; // 滑块圆角
  }
  &::-webkit-scrollbar-thumb:hover {
    background: $--scrollbar-thumb-hover-color; // 鼠标移入滑块hover
  }
  .form-title {
    position: absolute;
    line-height: 21px;
    color: $--color-text-regular;
    .form-desc {
      color: $--color-font-light;
    }
  }
}
.label-box {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: calc(100% - 33px);
  font-size: 14px;
  margin-bottom: 8px;
  cursor: pointer;
  .title {
    font-size: 14px;
    color: #606266;
  }
  &.flex-right {
    justify-content: flex-end;
  }
  .auto-trans {
    color: $--color-primary-6;
  }
  .is-disabled {
    color: #C0C4CC;
    cursor: not-allowed;
  }
  .hscode-text {
    margin-left: 4px;
  }
}
</style>